import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from '../DataTable.module.scss'

const withSelectRow = Component => {
	const SelectRowWrap = ({ selectRow, ...props }) => {
		const { data } = props
		const { defaultSelected, selected: controlledSelected, setSelectedRecord: setSelectedControled } = selectRow
		const isControlled = !!setSelectedControled || !!controlledSelected
		const [selected, setSelected] = useState(defaultSelected)
		const selectedRow = isControlled ? controlledSelected : selected
		const setSelectedRecord = isControlled ? setSelectedControled : setSelected
		const selectedRowIndex = data?.findIndex(({ id }) => id === selectedRow)
		const handleGetTrProps = (state, rowInfo) => {
			if(!rowInfo) {
				return {}
			}
			const { disabled, getTrProps } = props
			const definedTrProps = getTrProps ? getTrProps(state, rowInfo) : {}
			if(disabled) {
				return definedTrProps
			}
			const rowId = rowInfo.original.id
			return {
				...definedTrProps,
				onClick: (e) => {
					if(definedTrProps.onClick) {
						definedTrProps.onClick(e)
					}
					if(typeof setSelectedRecord === 'function') {
						setSelectedRecord(rowId)
					}
				},
				className: classNames({
					[definedTrProps.className]: definedTrProps.className,
					[style.selectRow]: rowId?.toString() === selectedRow?.toString()
				})
			}
		}

		const handleGetTrGroupProps = (state, rowInfo) => {
			const { getTrGroupProps } = props
			const definedTrGroupProps = getTrGroupProps ? getTrGroupProps(state, rowInfo) : {}
			return {
				...definedTrGroupProps,
				selected: String(rowInfo?.original?.id) === String(selectedRow)
			}
		}

		return(
			<Component
				{...props}
				withRowColorTag={true}
				getTrProps={handleGetTrProps}
				getTrGroupProps={handleGetTrGroupProps}
				tableBodyProps={{
					tabIndex: 100,
					onKeyDown: (e, s) => {
						if(e.keyCode === 38 || e.keyCode === 40) {
							const newSelectedIndex = e.keyCode === 38 ? selectedRowIndex - 1 : selectedRowIndex + 1
							if(newSelectedIndex > -1 && newSelectedIndex < data.length) {
								setSelectedRecord(data[newSelectedIndex]?.id)
								e.preventDefault()
							}
						}
					}
				}}
			/>
		)
	}

	SelectRowWrap.propTypes = {
		selectRow: PropTypes.oneOfType([PropTypes.shape({
			defaultSelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
		}), PropTypes.bool]).isRequired
	}
	return SelectRowWrap
}

export default withSelectRow
